import styles from './styles.module.css'

export function ItemDivider() {
  return <div className={styles.itemDivider} />
}

try{ ItemDivider.displayName ||= 'ItemDivider' } catch {}